/** Move item from `from` to `to` in a shallow copy of the array. */
export function reorderArray(arr, from, to) {
  if (!arr || from === to || from < 0 || to < 0 || from >= arr.length || to >= arr.length) {
    return arr ? [...arr] : []
  }
  const list = [...arr]
  const [item] = list.splice(from, 1)
  list.splice(to, 0, item)
  return list
}

/** Update a selected list index after reorderArray(from, to). */
export function remapIndexAfterMove(index, from, to) {
  if (index === from) return to
  if (from < to && index > from && index <= to) return index - 1
  if (from > to && index >= to && index < from) return index + 1
  return index
}

/** Find reorder drop target under the pointer for a given kind. */
export function findReorderTarget(clientX, clientY, kind, rootEl) {
  const scope = rootEl || document
  const nodes = scope.querySelectorAll(`[data-cfg-reorder="${kind}"]`)
  for (let i = 0; i < nodes.length; i++) {
    const el = nodes[i]
    const rect = el.getBoundingClientRect()
    if (
      clientX >= rect.left && clientX <= rect.right
      && clientY >= rect.top && clientY <= rect.bottom
    ) {
      const idx = parseInt(el.getAttribute('data-cfg-reorder-index'), 10)
      if (!Number.isNaN(idx)) return idx
    }
  }
  return -1
}
